import styled from "styled-components";

export const HeaderContainerStyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const HeaderMenuItemStyledDiv = styled.div`
  display: flex;
  height: 36px;
  padding: 0 12px;
  align-items: center;
  gap: 10px;
  font-weight: 700;
  font-size: 11px;
  letter-spacing: 0.5px;
  color: var(--DARK-GREY, #0e0e2c);
  text-transform: uppercase;
  border-bottom: 1px solid #edf0f5;
  margin-bottom: 6px;

  > svg {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
  }
`;

export const MenuItemStyledDiv = styled.div`
  a {
    display: flex;
    height: 34px;
    padding: 0 12px;
    align-items: center;
    gap: 8px;
    color: var(--Dark-Grey, #262641);
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    border-radius: 4px;
    transition: background-color 0.15s ease, color 0.15s ease;
    white-space: nowrap;

    > svg {
      width: 14px;
      height: 14px;
      flex-shrink: 0;
    }

    &:hover {
      color: var(--BLUE, #2060ea);
      background-color: var(--Mist, #f4f6fa);
      path {
        fill: var(--BLUE, #2060ea);
      }
    }
  }
`;

export const GlobalCreateMenuDiv = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 180px);
  gap: 20px 24px;
  padding: 18px 20px;
  width: max-content;
  max-width: calc(100vw - 120px);
  max-height: calc(100vh - 84px);
  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

  color: var(--Dark-Grey, #262641);
  font-family: Inter, sans-serif;
  font-size: 13px;
  font-style: normal;
  line-height: 18px;
  letter-spacing: 0.3px;

  position: absolute;
  z-index: 100;
  top: calc(100% + 8px);
  right: 0;

  border-radius: 8px;
  background: #fff;
  border: 1px solid var(--SILVER, #dadff3);
  box-shadow:
    0 4px 12px -2px rgba(14, 14, 44, 0.08),
    0 12px 28px 0 rgba(14, 14, 44, 0.12);

  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, 180px);
  }

  @media (max-width: 900px) {
    grid-template-columns: repeat(2, 180px);
  }

  /* Custom subtle scrollbar */
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    background: #d4d8e3;
    border-radius: 3px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
`;
